
export default {
  data() {
    return {
      page: 1,
      pageData: null,
      posts: null,
      category: [],
      pagination: false,
      loading: false,
      selectedCategory: null,
    };
  },
  watch: {
    page: {
      handler(val) {
        this.getPages();
      },
    },
    $route: {
      handler() {
        this.changeCategory();
      },
    },
  },
  mounted() {
    this.getPages();
  },
  methods: {
    changeCategory() {
      if (this.$route && this.$route.query && this.$route.query.category) {
        this.category = [this.$route.query.category];
        this.getPages();
      }
    },
    async getPages() {
      this.loading = true;
      this.posts = await this.$getCustomPost(
        this.category,
        ["Downloads"],
        6,
        this.page
      );
      this.loading = false;
      this.page = this.data.pagination.page;
    },
    getPageData() {
      this.pageData = this.$parent.$parent.pageData;
    },
    scrollToTop() {
      if (process.browser) {
        window.scrollTo(0, 0);
      }
    },
  },
};
